import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, Text, Flex, Alert, AlertIcon,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { deleteContentCreator } from '../../../../../store/contentCreators/contentCreatorsSlice';
import theme from '../../../../global/theme';

const DeleteModal = ({ data, onClose }) => {
  const dispatch = useDispatch();
  const contentCreators = useSelector(state => state.contentCreators);

  return (
    <Modal isOpen onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <ModalHeader textAlign="center" color="red.400" fontSize={20}>حذف صانع المحتوى</ModalHeader>
        <ModalBody>
          {contentCreators.errors.length > 0 && (
            <Alert status="error" variant="left-accent" marginBottom={4}>
              <AlertIcon />
              {contentCreators.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
            </Alert>
          )}
          <Text color={theme.light} textAlign="center">
            هل أنت متأكد من حذف <strong>{data.name}</strong>؟
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="center" gap={3} width="100%">
            <Button rightIcon={<FiIcons.FiTrash2 />} colorScheme="red" isLoading={contentCreators.isLoading}
              onClick={() => dispatch(deleteContentCreator(data)).unwrap().then(() => onClose())}>
              حذف
            </Button>
            <Button rightIcon={<FiIcons.FiX />} colorScheme="gray"
              isLoading={contentCreators.isLoading} onClick={onClose}>إلغاء</Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
